import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseDefaultListFilterComponent, QueryParameter } from 'yt-ng-framework';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { KomitentView } from 'src/app/lookups/komitent/komitent-view';
import { Router } from '@angular/router';
//import { baseDirectiveCreate } from '@angular/core/src/render3/instructions';

@Component({
    selector: 'filter-with-komitent',
    templateUrl: './filter-with-komitent.component.html'
})
export class FilterWithKomitentComponent extends BaseDefaultListFilterComponent {
    loadingEUInvoiceStatus:boolean = false;
    StatusDescription:string="";
    collapsed1:boolean=true;
    StatusRefreshTime:Date;
    @Output() RefreshStatusClicked = new EventEmitter();
    @Input() showStatusBox:boolean=false;

    constructor(protected datePipe: DatePipe
    ){
        super(datePipe);
    }

    selectedKomitent: string = 'Svi';

    ngOnInit(){
        this.SetInitParameters();
    }

    SelectKomitent(item: KomitentView){
        this.selectedKomitent = item != null ? item.Naziv + ', ' + item.Mesto : 'Svi';
        this.SetFilterDescription();
    }
    
    SetFilterDescription(){
        super.SetFilterDescription();
        this.selectedKomitent = this.filterFormGroup.get('KomitentID').value ? this.selectedKomitent : 'Svi';
        this.FilterDescription = 'Od: ' + this.GetPropertyValue(this.filterFormGroup.get('DateFrom').value, 'date') + 
                                 ', Do: ' + this.GetPropertyValue(this.filterFormGroup.get('DateTo').value, 'date') +
                                 ', Komitent: ' + this.selectedKomitent;
    }

    SetStatusDescription(){
        this.StatusDescription='Osveženo '
         +this.StatusRefreshTime.getHours().toString().padStart(2, "0")
          +":"+this.StatusRefreshTime.getMinutes().toString().padStart(2, "0")
          +":"+this.StatusRefreshTime.getSeconds().toString().padStart(2, "0")
         +' za dokumenta stara do '
         +this.filterFormGroup.get("DanaZaOsvezavanje").value.toString()
         +' dana.';
    }


    SetInitParameters(){
        super.SetInitParameters();

        const date = new Date();
        this.filterFormGroup = new FormGroup({
            DateFrom: new FormControl(new NgbDate(date.getFullYear(), 1, 1)),
            DateTo: new FormControl(new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate())),
            KomitentID: new FormControl(null),
            DanaZaOsvezavanje: new FormControl(5),
        });

        // const date = new Date();
        // this.defaultFilterValues  = {
        //     DateFrom: new NgbDate(date.getFullYear(), 1, 1),
        //     DateTo: new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate()),
        //     KomitentID: null,
        //     DanaZaOsvezavanje: 3,
        // };

        
        // this.filterFormGroup = new FormGroup({
        //     DateFrom: new FormControl(this.defaultFilterValues.DateFrom, [Validators.required]),
        //     DateTo: new FormControl(this.defaultFilterValues.DateTo, [Validators.required]),
        //     KomitentID: new FormControl(this.defaultFilterValues.KomitentID),
        //     DanaZaOsvezavanje: new FormControl(this.defaultFilterValues.DanaZaOsvezavanje),
        // });
    
        // this.loadFilterFromStorage('filter');
    }

    // RefreshStatusClick(id : number){
    RefreshStatusClick(){
        this.RefreshStatusClicked.emit(this.filterFormGroup.get("DanaZaOsvezavanje").value);
        this.StatusRefreshTime=new Date();
        this.SetStatusDescription();
        this.collapsed1=true;
    }
}